import { categoricalColors10, categoricalColors20 } from 'visyn_core/utils';

export const colorMap: { [key: string]: string } = {
  // Ig isotypes
  IGHG: categoricalColors10[9] as string,
  IGHM: categoricalColors10[1] as string,
  IGHA2: categoricalColors10[2] as string,
  IGHA1: categoricalColors10[3] as string,
  IGHG3: categoricalColors10[4] as string,
  IGHG2: categoricalColors10[5] as string,
  IGHG4: categoricalColors10[6] as string,
  IGHE: categoricalColors10[7] as string,
  IGHG1: categoricalColors20[0] as string,

  // leiden clusters
  '0': categoricalColors10[0] as string,
  '1': categoricalColors10[1] as string,
  '2': categoricalColors10[2] as string,
  '3': categoricalColors10[3] as string,
  '4': categoricalColors10[4] as string,
  '5': categoricalColors10[5] as string,
  '6': categoricalColors10[6] as string,
  '7': categoricalColors10[7] as string,
  '8': categoricalColors10[8] as string,
  '9': categoricalColors10[9] as string,
  '10': categoricalColors20[10] as string,
};

export const getClonotypeIdColor = (clonotypeId: number) => {
  if (!clonotypeId) {
    return categoricalColors20[0];
  }
  return categoricalColors20[clonotypeId % 20];
};
/**
 * SHM bucket -> colour, ordered fewest mutations first.
 * Keys are the buckets produced by add_shm_category() in stellar/lib/ir_operations.py.
 */
export const SHM_COLOR_SCALE = [
  { key: '0', label: '0', color: '#c6dbef' },
  { key: '1-3', label: '1-3', color: '#9ecae1' },
  { key: '4-6', label: '4-6', color: '#6baed6' },
  { key: '7-9', label: '7-9', color: '#4292c6' },
  { key: '10-19', label: '10-19', color: '#2171b5' },
  { key: '20+', label: '20+', color: '#084594' },
] as const;

const SHM_COLORS: { [category: string]: string } = Object.fromEntries(SHM_COLOR_SCALE.map((s) => [s.key, s.color]));

export const getShmCategoryColor = (shmCategory: string | null | undefined): string | undefined => (shmCategory ? SHM_COLORS[shmCategory] : undefined);
